import React, { useEffect, useState } from 'react'
import style from './Features.module.css'
import item from "../../json/Homepage/Featuers.json"

const Features = ({ activeTab, setActiveTab }) => {

    const [isMobile, setIsMobile] = useState(false);

    const [openFeatureIndex, setOpenFeatureIndex] = useState(null)
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 500);
        };
        handleResize();

        // Listen for resize
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);



    const renderContent = () => {
        switch (activeTab) {
            case 'Advantages':
                return (
                    <div className={style.boxcontainer}>
                        <div className={style.featureImagecontainer}>
                            <img src={process.env.PUBLIC_URL + item.Advantages.image} alt="Advantages" />
                        </div>
                        <div className={style.contentContainer}>
                            <h1 className={style.featuebigfont}>{item.Advantages.content}</h1>
                            <div className={style.itemPoints}>
                                {item.Advantages.points.map((point, idx) => (
                                    <div className={style.pointItem} key={idx}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1076_4033)">
                                                <path d="M17 3.33989C18.5083 4.21075 19.7629 5.46042 20.6398 6.96519C21.5167 8.46997 21.9854 10.1777 21.9994 11.9192C22.0135 13.6608 21.5725 15.3758 20.72 16.8946C19.8676 18.4133 18.6332 19.6831 17.1392 20.5782C15.6452 21.4733 13.9434 21.9627 12.2021 21.998C10.4608 22.0332 8.74055 21.6131 7.21155 20.7791C5.68256 19.9452 4.39787 18.7264 3.48467 17.2434C2.57146 15.7604 2.06141 14.0646 2.005 12.3239L2 11.9999L2.005 11.6759C2.061 9.94888 2.56355 8.26585 3.46364 6.79089C4.36373 5.31592 5.63065 4.09934 7.14089 3.25977C8.65113 2.42021 10.3531 1.98629 12.081 2.00033C13.8089 2.01437 15.5036 2.47589 17 3.33989ZM15.707 9.29289C15.5348 9.12072 15.3057 9.01729 15.0627 9.002C14.8197 8.98672 14.5794 9.06064 14.387 9.20989L14.293 9.29289L11 12.5849L9.707 11.2929L9.613 11.2099C9.42058 11.0607 9.18037 10.9869 8.9374 11.0022C8.69444 11.0176 8.46541 11.121 8.29326 11.2932C8.12112 11.4653 8.01768 11.6943 8.00235 11.9373C7.98702 12.1803 8.06086 12.4205 8.21 12.6129L8.293 12.7069L10.293 14.7069L10.387 14.7899C10.5624 14.926 10.778 14.9998 11 14.9998C11.222 14.9998 11.4376 14.926 11.613 14.7899L11.707 14.7069L15.707 10.7069L15.79 10.6129C15.9393 10.4205 16.0132 10.1802 15.9979 9.93721C15.9826 9.69419 15.8792 9.46509 15.707 9.29289Z" fill="#F44F0D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1076_4033">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <p className={style.featurepoints}>{point}</p>
                                    </div>

                                ))}
                            </div>

                        </div>
                    </div>
                )

            case 'UniqueFeatures':
                return (
                    <div className={style.boxcontainer}>
                        <div className={style.featureImagecontainer}>
                            <img src={process.env.PUBLIC_URL + item.UniqueFeatures.image} alt="Unique Features" />
                        </div>
                        <div className={style.contentContainer}>
                            {item.UniqueFeatures.data.map((feature, idx) => (
                                <div key={idx} className={style.featureItem}>
                                    <div className={style.featureTitle}>
                                        <p style={{ display: "inline-block" }} className={style.featuretitle}>{feature.title}</p>
                                        <button
                                            onClick={() =>
                                                setOpenFeatureIndex(openFeatureIndex === idx ? null : idx)
                                            }
                                        >
                                            {openFeatureIndex === idx ? (<>
                                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="28" height="28" rx="14" fill="#3D3D41" />
                                                    <path d="M8.75 14H19.25" stroke="#D9D7DE" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>


                                            </>) : (<><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="28" height="28" rx="14" fill="#3D3D41" />
                                                <path d="M8.75 14H19.25" stroke="#D9D7DE" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M14 8.75V19.25" stroke="#D9D7DE" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            </>)}
                                        </button>
                                    </div>
                                    {openFeatureIndex === idx && <p className={style.featureanswer}>{feature.description}</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                )

            case 'ForPublisher':
                return (
                    <div className={style.boxcontainer}>
                        <div className={style.featureImagecontainer}>
                            <img src={process.env.PUBLIC_URL + item.ForPublisher.image} alt="For Publisher" />
                        </div>
                        <div className={style.contentContainer}>
                            <h1 className={style.featuebigfont}>{item.ForPublisher.content}</h1>
                        </div>
                    </div>
                )

            case 'KeyAspects':
                return (
                    <div className={style.boxcontainer}>
                        <div className={style.featureImagecontainer} >
                            <img src={process.env.PUBLIC_URL + item.KeyAspects.image} alt="Key Aspects" />
                        </div>
                        <div className={style.contentContainer}>
                            <div className={style.itemPoints}>
                                {item.KeyAspects.points.map((point, idx) => (
                                    <div className={style.pointItem} key={idx}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1076_4033)">
                                                <path d="M17 3.33989C18.5083 4.21075 19.7629 5.46042 20.6398 6.96519C21.5167 8.46997 21.9854 10.1777 21.9994 11.9192C22.0135 13.6608 21.5725 15.3758 20.72 16.8946C19.8676 18.4133 18.6332 19.6831 17.1392 20.5782C15.6452 21.4733 13.9434 21.9627 12.2021 21.998C10.4608 22.0332 8.74055 21.6131 7.21155 20.7791C5.68256 19.9452 4.39787 18.7264 3.48467 17.2434C2.57146 15.7604 2.06141 14.0646 2.005 12.3239L2 11.9999L2.005 11.6759C2.061 9.94888 2.56355 8.26585 3.46364 6.79089C4.36373 5.31592 5.63065 4.09934 7.14089 3.25977C8.65113 2.42021 10.3531 1.98629 12.081 2.00033C13.8089 2.01437 15.5036 2.47589 17 3.33989ZM15.707 9.29289C15.5348 9.12072 15.3057 9.01729 15.0627 9.002C14.8197 8.98672 14.5794 9.06064 14.387 9.20989L14.293 9.29289L11 12.5849L9.707 11.2929L9.613 11.2099C9.42058 11.0607 9.18037 10.9869 8.9374 11.0022C8.69444 11.0176 8.46541 11.121 8.29326 11.2932C8.12112 11.4653 8.01768 11.6943 8.00235 11.9373C7.98702 12.1803 8.06086 12.4205 8.21 12.6129L8.293 12.7069L10.293 14.7069L10.387 14.7899C10.5624 14.926 10.778 14.9998 11 14.9998C11.222 14.9998 11.4376 14.926 11.613 14.7899L11.707 14.7069L15.707 10.7069L15.79 10.6129C15.9393 10.4205 16.0132 10.1802 15.9979 9.93721C15.9826 9.69419 15.8792 9.46509 15.707 9.29289Z" fill="#F44F0D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1076_4033">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <p className={style.featurepoints}>{point}</p>
                                    </div>

                                ))}
                            </div>

                        </div>
                    </div>
                )

            default:
                return null
        }
    }

    return (
        <div id="features" className={style.featuresBackground}>
            <div className='container'>
                <div className={style.featurecontainer}>
                    <div className={style.containerSafer}>
                        <div className={style.textgroup}>
                            <p className={style.featureheading}>{'{ features }'}</p>
                            <h2 className={style.featureh2}>Effortless LaTeX Proofing for STM Publishing</h2>
                            <p className={style.featurep}>
                                LaTeX simplifies writing equations, while EditLaTeX ensures easy, accurate, and error-free proofing for STM publishing.
                            </p>
                        </div>
                        {
                            !isMobile ? (<>
                                <div className={style.buttonGrouping}>
                                    <button
                                        className={activeTab === 'Advantages' ? style.activeTab : style.featurebutton}
                                        onClick={() => setActiveTab('Advantages')}
                                    >
                                        Advantages
                                    </button>
                                    <button
                                        className={activeTab === 'UniqueFeatures' ? style.activeTab : style.featurebutton}
                                        onClick={() => setActiveTab('UniqueFeatures')}
                                    >
                                        Unique Features
                                    </button>
                                    <button
                                        className={activeTab === 'ForPublisher' ? style.activeTab : style.featurebutton}
                                        onClick={() => setActiveTab('ForPublisher')}
                                    >
                                        For Publisher
                                    </button>
                                    <button
                                        className={activeTab === 'KeyAspects' ? style.activeTab : style.featurebutton}
                                        onClick={() => setActiveTab('KeyAspects')}
                                    >
                                        Key Aspects
                                    </button>
                                </div>
                            </>) : (<>

                                <div className={style.mobileDropdown}>
                                    <select
                                        value={activeTab}
                                        onChange={(e) => setActiveTab(e.target.value)}
                                    >
                                        <option value="Advantages">Advantages</option>
                                        <option value="UniqueFeatures">Unique Features</option>
                                        <option value="ForPublisher">For Publisher</option>
                                        <option value="KeyAspects">Key Aspects</option>
                                    </select>
                                </div>
                            </>)
                        }


                        <div>{renderContent()}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features
